

//lodash
window._ = require('lodash');

// import * as Cookies from 'js-cookie';

//Cookies.set('utm',JSON.stringify({utm_source:11,utm_medium:'',utm_campaign:'',utm_content:'',utm_term:''}),{ expires: 365 })

//稿件可以访问
// if(window.location.pathname.indexOf("manuscripts")==-1)
// {

//     const authPage = ['/login','/signup','/retrievepwd'].indexOf(window.location.pathname)>-1;

// }



// WEBPACK FOOTER //
// ./src/Bootstrap.js